import {createNativeStackNavigator} from '@react-navigation/native-stack';
import React, {useState, useEffect} from 'react';
import {TouchableOpacity, View, Text, Image, ScrollView, StyleSheet, BackHandler, Alert, Platform} from 'react-native';
import GoBack_btn_copy from '../src/components/Header/goBack';
import ModalNavigation from '../routes/modalNavigation';

import WebViewComp from '../src/components/WebView';

import HeaderCenter from '../src/components/Header/headerCenter';
import HeaderLeft from '../src/components/Header/headerLeft';
import HeaderRight from '../src/components/Header/headerRight';

import * as FileSystem from 'expo-file-system';
import { IconArrowRight } from '../src/theme/icons';
import { useIsFocused } from '@react-navigation/native';
import images from '../src/theme/images';

let fileUri = FileSystem.cacheDirectory + "user.txt";

function MenuModal({navigation, route}) {
  let tabNavi = route.params.tabNavi;
  let navigationMenuItems = route.params.hamburgerSettings.hamburgerMenuItems;
  let menuSettings = route.params.hamburgerSettings;
  return (
    <ScrollView 
      bounces={false} 
      showsHorizontalScrollIndicator={false}
      showsVerticalScrollIndicator={false}
      style={{backgroundColor: menuSettings.backgroundColor, flex: 1}}
    >
      {
        navigationMenuItems.map(function(item, index){
          return (
            <TouchableOpacity 
              key={index}
              onPress={async () => {
                let title = item.title.toLowerCase();
                if(title.includes("sign out") || title.includes("logout")){
                  navigation.pop();
                  let userFile = await FileSystem.deleteAsync(fileUri);
                  navigation.push("LoginScreen", {url: item.url});
                } else {
                  var url = item.url;
                  var siteURL = route.params.tabNavi.siteURL;
              
                  if(url.startsWith("/")){
                    url = siteURL + url;
                  }
              
                  if (url.includes("?") || url.includes("stripe")){
                    console.log("do nothing");
                  } else {
                    if (url.substr(-1) != '/') {url += '/'}
                  }

                  navigation.push("MenuItem", {
                    siteURL: tabNavi.siteURL,
                    url: item.url, 
                    screenName: item.title,
                    img: tabNavi.img,
                    hideThis: tabNavi.hideThis,
                    bottomBarPages: tabNavi.bottomBarPages,
                    loadingColor: tabNavi.loadingColor,
                    topNavStyle: route.params.tabNavi.topNavStyle
                  })
                }
              }}
              style={styles.navigationMenuItems}
            >
              <View style={styles.navigationMenuItemContainer}>
                {
                  item.icon !== "" && (
                    <Image 
                      source={{uri: item.icon}} 
                      style={[styles.navigationMenuIcon, { tintColor: menuSettings.fontColor }]} 
                      tintColor={ menuSettings.fontColor } 
                    />
                  )
                }
                <Text style={[{color: menuSettings.fontColor}, styles.navigationMenuItemText]}>{item.title}</Text>
              </View>
                {
                  Platform.OS !== "web" ? (
                    <IconArrowRight style={{color: menuSettings.fontColor}} />
                  ) : (
                    <Image source={images.rightIcon} style={styles.rightImage} />
                  )
                }
            </TouchableOpacity>
          )
        })
      }
    </ScrollView>
  )
}

const Navigation = createNativeStackNavigator();

function NavigationScreen({ navigation, route }) {
    var url = route.params.url;
    var siteURL = route.params.siteURL;

    if(url.startsWith("/")){
      url = siteURL + url;
    }

    if (url.includes("?") || url.includes("stripe")){
      console.log("do nothing");
    } else {
      if (url.substr(-1) != '/') {url += '/'}
    }

    useEffect(() => {
      const backAction = () => {
          if ( navigation.canGoBack() ){
              navigation.goBack();
          } else{
              Alert.alert("Hold on!", "Are you sure you want to exit?", [
                  {
                    text: "Cancel",
                    onPress: () => null,
                    style: "cancel"
                  },
                  { text: "YES", onPress: () => { BackHandler.exitApp(); }}
                ]);
          }
        return true;
      };
  
      const backHandler = BackHandler.addEventListener(
        "hardwareBackPress",
        backAction
      );
  
      return () => backHandler.remove();
    }, []);    
    const isFocused = useIsFocused()
    return (
        <View style={styles.navigationItemScreen}>          
        {
          <View style={styles.webViewContainer}>
            <WebViewComp 
                siteURL={route.params.siteURL}
                url={url} 
                navigation={navigation} 
                screenName={route.params.screenName} 
                route={route} 
                hideThis={route.params.hideThis}
                bottomBarPages={route.params.bottomBarPages}
                loadingColor={route.params.loadingColor}
                isFocused={isFocused}
                loadStripe={route.params.loadStripe}
                endFlowURLS={route.params.endFlowURLS}
            />
          </View>
        }
        </View>
    );
}

class TabNavi extends React.Component {
    render(){      
        let tabNavi = this.props;
        var url = tabNavi.url;
        var siteURL = tabNavi.siteURL;
    
        if(url.startsWith("/")){
          url = siteURL + url;
        }
    
        if (url.includes("?") || url.includes("stripe")){
          console.log("do nothing");
        } else {
          if (url.substr(-1) != '/') {url += '/'}
        }
        return (
            <Navigation.Navigator>
              <Navigation.Group>
                <Navigation.Screen
                  name={tabNavi.screenName}
                  component={NavigationScreen}
                  initialParams={{
                    siteURL: tabNavi.siteURL,
                    screenName: tabNavi.screenName,
                    url: tabNavi.url,
                    img: tabNavi.img,
                    hideThis: tabNavi.hideThis,
                    bottomBarPages: tabNavi.bottomBarPages,
                    loadingColor: tabNavi.loadingColor,
                    topNavStyle: tabNavi.topNavStyle,
                    endFlowURLS: tabNavi.endFlowURLS
                  }}
                  options={({...props}) => (
                    {
                    gestureEnabled: false,
                    gestureEnabled: true,
                    headerShown: true,
                    headerBackVisible:false,
                    headerTitleAlign: 'center',
                    // title: props.route.params.url.includes("stripe") ? "Stripe Checkout" : props.route.params.url.replace(/\/+$/, '').split("/").pop().split("?")[0].replace("/", "").replace(/-/g, " ").replace(/^\w/, (c) => c.toUpperCase()),
                    headerTransparent: false,
                    headerShadowVisible: false,
                    headerStyle: {
                        backgroundColor: tabNavi.topNavStyle.styles.backgroundColor,
                        color: tabNavi.topNavStyle.styles.topBarTextColor
                    },
                    headerLeft: () => (
                        <HeaderLeft 
                            navigation={props.navigation} 
                            type={tabNavi.topNavConfig.designType}
                            isAfterInitial={props.route.params.isAfterInitial}
                            screenName={tabNavi.screenName}
                            config={tabNavi.topNavConfig}
                            headerStyle={tabNavi.topNavStyle}
                            hideThis={tabNavi.hideThis} 
                        />
                    ),
                    headerRight: () => (
                      <HeaderRight 
                        navigation={props.navigation} 
                        type={tabNavi.topNavConfig.designType}
                        isAfterInitial={props.route.params.isAfterInitial}
                        config={tabNavi.topNavConfig}
                        headerStyle={tabNavi.topNavStyle}
                        hideThis={tabNavi.hideThis} 
                      />
                    ),
                    headerTitle: () => (
                      <HeaderCenter 
                          props={props} 
                          type={tabNavi.topNavConfig.designType}
                          isAfterInitial={props.route.params.isAfterInitial}
                          title={props.route.params.url.includes("stripe") ? "Stripe Checkout" : props.route.params.url.replace(/\/+$/, '').split("/").pop().split("?")[0].replace("/", "").replace(/-/g, " ").replace(/^\w/, (c) => c.toUpperCase())}
                          config={tabNavi.topNavConfig}
                          headerStyle={tabNavi.topNavStyle}
                          hideThis={tabNavi.hideThis} 
                      />
                    ),
                  })}
                />
                <Navigation.Screen 
                  name="MenuModal" 
                  component={MenuModal}
                  initialParams={{
                    tabNavi: tabNavi,
                    topNavStyle: tabNavi.topNavStyle,
                  }}
                  options={({...props}) => ({
                    gestureEnabled: true,
                    headerShown: true,
                    title: "",
                    headerTransparent: false,
                    headerShadowVisible: false,
                    headerStyle: {
                      backgroundColor: tabNavi.topNavStyle.styles.backgroundColor,
                    },
                    headerTitleAlign: 'center',
                    headerLeft: () => <GoBack_btn_copy navigation={props.navigation} color={tabNavi.topNavStyle.styles.topBarIconColor} setIsActive={tabNavi.setIsActive}/>
                  })} 
                />
                <Navigation.Screen
                  name="MenuItem"
                  component={ModalNavigation}
                  initialParams={{
                    tabNavi: tabNavi,
                    topNavStyle: tabNavi.topNavStyle,
                  }}
                  options={({...props}) => ({
                    presentation: "modal",
                    headerShown: false
                  })}
                />
              </Navigation.Group>
            </Navigation.Navigator>
          );
    }
    
}

const styles = StyleSheet.create({
  navigationMenuItems:{
    padding: 15, 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    borderBottomColor: "rgba(178,178,178,0.81)", 
    borderBottomWidth: 0.5, 
    alignItems: 'center'
  },
  navigationMenuItemContainer:{
    flexDirection: 'row', 
    justifyContent: 'center',
    alignItems: 'center'
  },
  navigationMenuIcon:{
    width: 24, 
    height: 24, 
    resizeMode: 'contain', 
    marginRight: 12
  },
  navigationMenuItemText:{
    fontWeight: "500", 
    fontSize: 16
  },
  navigationItemScreen:{ 
    flex: 1, 
    alignItems: 'center', 
    justifyContent: 'center' 
  },
  webViewContainer: {
    flex: 1, 
    width: "100%"
  },
  rightImage: {
    width: 10, 
    height: 10, 
    resizeMode: 'contain'
  },
});

export default TabNavi;
